// extracted by mini-css-extract-plugin
export var actionText = "_pf-4";
export var container = "_pf-0";
export var leftSection = "_pf-1";
export var rightSection = "_pf-2";
export var settingsButton = "_pf-6";
export var settingsIcon = "_pf-7";
export var shortcut = "_pf-5";
export var shortcutGroup = "_pf-3";